import {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";

const ThemeContext =
    createContext();

export const ThemeProvider = ({
    children,
}) => {

    const [theme, setTheme] =
        useState(
            localStorage.getItem(
                "theme",
            ) || "light",
        );

    useEffect(() => {

        const root =
            window.document.documentElement;

        root.classList.remove(
            "light",
            "dark",
        );

        root.classList.add(theme);

        localStorage.setItem(
            "theme",
            theme,
        );

    }, [theme]);

    const toggleTheme = () => {
        setTheme((prev) =>
            prev === "dark"
                ? "light"
                : "dark",
        );
    };

    return (
        <ThemeContext.Provider
            value={{
                theme,
                toggleTheme,
            }}
        >
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () =>
    useContext(ThemeContext);